import { useCallback, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { useFormikContext } from 'formik'

import { setFormValidity } from '../../../sale/store'
import { CustomerFormModel } from '../../model/customer.model'
import { setFields } from '../../store/customer.reducer'

export default function useContactForm() {
  const dispatch = useDispatch()
  const { values, isValid } = useFormikContext<Partial<CustomerFormModel>>()
  const setCustomerValues = useCallback(() => dispatch(setFields(values)), [values, dispatch])

  function setCustomerIsValid(isCustomerValid: boolean) {
    dispatch(setFormValidity({ lineId: 'mainLine', form: 'customer', isValid: isCustomerValid }))
  }

  useEffect(() => {
    setCustomerValues()
  }, [values, dispatch])

  useEffect(() => {
    setCustomerIsValid(isValid)
    return () => setCustomerIsValid(true)
  }, [isValid])
}
